import React from 'react'
import { connect } from 'react-redux'

import AnyEnsure from 'common/core/components/AnyEnsure/AnyEnsure'
import { fetchTargetPageTags } from 'common/mapping/store'

class EnsureTags extends React.Component {
  componentDidMount() {
    if (!this.props.items && !this.props.fetching && this.props.pageId) {
      this.props.fetchTargetPageTags(this.props.pageId)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageId && prevProps.pageId !== this.props.pageId) {
      this.props.fetchTargetPageTags(this.props.pageId)
    }
  }

  render() {
    const { children, ...rest } = this.props
    return <AnyEnsure {...rest}>{children}</AnyEnsure>
  }
}

const ensureTags = connect(
  (state) => ({
    items: state.targetPage.tags.items,
    fetching: state.targetPage.tags.fetching,
  }),
  (dispatch) => ({
    fetchTargetPageTags: (pageId) => dispatch(fetchTargetPageTags(pageId)),
  }),
)(EnsureTags)

export default ensureTags
